import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';

import { SearchActiveFacets } from '@uncinc/react-searchkit';
import type { SearchActiveFacetsProps } from '@uncinc/react-searchkit/dist/components/ActiveFacets';
import type { SearchResetButtonProps } from '@uncinc/react-searchkit/dist/components/Reset';

import { Button } from '@uncinc/uncinc-react-kitchen-sink';

import '../../SearchGeneral/Styles/_activefacets.scss';

const ResetAllButton = (buttonProps: SearchResetButtonProps) => {
  const { t } = useTranslation();

  return (
    <Button {...buttonProps} className="link">
      {t('components.search_general.buttons.reset_refinements')}
    </Button>
  );
};

const SearchOcularDBActiveFacets: React.FC<SearchActiveFacetsProps> = (props) => {
  const { className, ...restProps } = props;

  const { t } = useTranslation();

  const classNames = c('SearchOcularDB__ActiveFacets', 'Tag--stretch-clickable-area', className);

  return (
    <SearchActiveFacets
      {...restProps}
      className={classNames}
      title={t('components.search_general.active_facets.title')}
      showResetAll
      resetAllProps={{
        button: ResetAllButton,
      }}
    />
  );
};

export default SearchOcularDBActiveFacets;
